import {appBarMedia} from '@/styles/appBarMq';
import useMediaQuery from './useMediaQuery';

const useIsAppBarLg = (): boolean => {
  return useMediaQuery(appBarMedia.lg);
};

export default useIsAppBarLg;
